<template>
  <iModal
    :visible="reviewInviteModalOpen"
    title="Review Invitation"
    :max-width="600"
    @close="closeModal"
  >
    <template #body>
      <iColumn gap="large">
        <iColumn gap="none">
          <iSubHeading font-size="standard">
            Publication:
          </iSubHeading>
          <iText>{{ invite.publicationName || 'N/A' }}</iText>
        </iColumn>
        <iText v-if="error" variant="error">
          {{ error }}
        </iText>
      </iColumn>
    </template>
    <template #footer>
      <iRow align="right" gap="standard">
        <iColumn width="hug">
          <iButton
            variant="secondary"
            :is-loading="isLoadingDeclineInvite"
            loading-spinner-position="inside"
            @click="decline"
          >
            Decline
          </iButton>
        </iColumn>
        <iColumn width="hug">
          <iButton
            variant="primary"
            :is-loading="isLoadingAcceptInvite"
            loading-spinner-position="inside"
            @click="accept"
          >
            Accept
          </iButton>
        </iColumn>
      </iRow>
    </template>
  </iModal>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useNetworkStore } from "@/stores/network-store";

export default {
  name: "ReviewInviteModal",
  computed: {
    ...mapState(useNetworkStore, [
      "reviewInviteModalOpen",
      "selectedInvite",
      "isLoadingAcceptInvite",
      "isLoadingDeclineInvite",
      "error",
    ]),
    invite() {
      return this.selectedInvite || {};
    },
  },
  methods: {
    ...mapActions(useNetworkStore, [
      "acceptInvite",
      "declineInvite",
      "closeReviewInviteModal",
    ]),
    closeModal() {
      this.closeReviewInviteModal();
    },
    accept() {
      if (!this.invite.networkId || !this.invite.publicationId) {
        return;
      }
      this.acceptInvite(this.invite.networkId, this.invite.publicationId);
    },
    decline() {
      if (!this.invite.networkId || !this.invite.publicationId) {
        return;
      }
      this.declineInvite(this.invite.networkId, this.invite.publicationId);
    },
  },
};
</script>

<style scoped>
</style>
